module.exports = __webpack_public_path__ + "img/vip-crowd_cclub_600.f53df28d.png";